import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
    getInvoiceOptions,
    saveInvoiceOptions,
} from '../api/invoice-options-api';
import { InvoiceOptions } from '../models/invoice-options';
import {
    apiCallError,
    beginApiCall,
    endApiCall,
} from '../store/api/api-status-action';

export const useInvoiceOptions = (): [
    InvoiceOptions[],
    boolean | null,
    string,
    (items: InvoiceOptions[]) => Promise<boolean>
] => {
    const [warrantyPreferences, setWarrantyPreferences] = useState<
        InvoiceOptions[]
    >([]);
    const [error, setError] = useState<string>('');
    const [isLoading, setIsLoading] = useState<boolean | null>(null);

    const dispatch = useDispatch();

    const fetchData = async () => {
        try {
            dispatch(beginApiCall());
            const response = await getInvoiceOptions();
            if (response.ok) {
                setWarrantyPreferences(response.data!);
            }
            dispatch(endApiCall());
        } catch (e) {
            const error = e as Error;
            dispatch(apiCallError(error as Error));
            setError(error.message);
        }

        setIsLoading(false);
    };

    const saveData = async (items: InvoiceOptions[]): Promise<boolean> => {
        try {
            dispatch(beginApiCall());
            const response = await saveInvoiceOptions(items);
            dispatch(endApiCall());
            return response;
        } catch (e) {
            const error = e as Error;
            dispatch(apiCallError(error));
            setError(error.message);
        }

        return false;
    };

    useEffect(() => {
        setIsLoading(true);
        fetchData();
    }, []);

    return [warrantyPreferences, isLoading, error, saveData];
};
